// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__2JHSJ","hasBorder":"card_hasBorder__4cwZ4","cardHeader":"card_cardHeader__n9lLa"};